import React from "react";
import Axios from "axios";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getRivileServices,
  updateRivileServices,
  deleteRivileService,
  postRivileService,
  clearErrors,
} from "../../redux/Actions/rivileServiceAction";
import RivileServiceEditModal from "./Items/RivileServiceEditModal";
import ContentBlock from "../Layout/ContentBlock";
import TableColumnRivileService from "./Items/TableColumnRivileService";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import PaginationComp from "../Dashboard/items/Pagination";
import { orderShopsOptions } from "../../redux/Actions/orderAction";
import InputText from "../orders/accepted_orders/InputFilter";
import { SelectForm } from "../common/Buttons";

const emptyFilter = {
  title: "",
  rivile_code: "",
  order_shop_id: undefined,
  document_type_id: undefined,
  assigned: undefined,
};

class RivileServiceTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredId: 0,
      page: 1,
      pageCount: 100,
      action: "new",
      shops: [],
      documentTypes: [],
      paramsFilter: "",
      filter: { ...emptyFilter },
    };
  }

  componentDidMount() {
    this.reloadData();
    orderShopsOptions().then((shops) => this.setState({ shops }));
    this.loadDocumentTypes();
  }
  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.reloadData();
    }
  }

  loadDocumentTypes = () => {
    Axios.get("/api/v1/document_types")
      .then((response) => {
        const documentTypes = (response.data || []).map((documentType) => ({
          label: documentType.name,
          value: documentType.id,
        }));
        this.setState({ documentTypes });
      })
      .catch(() => this.setState({ documentTypes: [] }));
  };

  reloadData = () => {
    this.props.getRivileServices(
      this.state.page,
      this.state.pageCount,
      this.state.paramsFilter
    );
  };

  onAction = (action, index) => {
    this.setState({
      requiredId: index,
      action: action,
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };

  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  onFilter = () => {
    let filterParams = [];
    if (this.state.filter.title.length > 0)
      filterParams.push(`&q[title_i_cont_any]=${this.state.filter.title}`);
    if (this.state.filter.rivile_code.length > 0)
      filterParams.push(
        `&q[rivile_code_i_cont_any]=${this.state.filter.rivile_code}`
      );
    if (this.state.filter.order_shop_id)
      filterParams.push(
        `&q[order_shops_id_eq]=${this.state.filter.order_shop_id}`
      );
    if (this.state.filter.document_type_id)
      filterParams.push(`&document_type_id=${this.state.filter.document_type_id}`);
    if (this.state.filter.assigned)
      filterParams.push(`&assigned=${this.state.filter.assigned}`);
    this.setState(
      {
        paramsFilter: filterParams.join(""),
        page: 1,
      },
      () => this.reloadData()
    );
  };

  filterChange = (e) => {
    const reload_data = [
      "order_shop_id",
      "document_type_id",
      "assigned",
    ].includes(e.target.name);
    this.setState(
      {
        filter: {
          ...this.state.filter,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        if (reload_data) this.onFilter();
      }
    );
  };
  render() {
    const requiredItem = this.state.requiredId;
    let modalData = this.props.rivileService[requiredItem]
      ? this.props.rivileService[requiredItem]
      : [];
    return (
      <Container
        location={{
          locationName: "Rivile services",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            totals={this.props.totals}
            length={this.props.rivileService.length}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text2="Rivile services"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox
            clearFilter={() =>
              this.setState(
                {
                  filter: { ...emptyFilter },
                },
                () => this.onFilter()
              )
            }
            add={this.onAction}
          >
            <div className="px-1">
              <InputText
                name="title"
                placeholder="Title"
                style={{ width: 150, fontSize: "0.75rem" }}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    this.onFilter();
                  }
                }}
                value={this.state.filter.title}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            <div className="px-1">
              <InputText
                name="rivile_code"
                placeholder="Rivile code"
                style={{ width: 150, fontSize: "0.75rem" }}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    this.onFilter();
                  }
                }}
                value={this.state.filter.rivile_code}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            <div className="px-1" style={{ minWidth: "150px" }}>
              <SelectForm
                placeholder="Store"
                dropdownMatchSelectWidth={false}
                options={[{ label: "Visi", value: null }, ...this.state.shops]}
                onChange={(value) =>
                  this.filterChange({
                    target: { name: "order_shop_id", value },
                  })
                }
                value={this.state.filter.order_shop_id}
              />
            </div>
            <div className="px-1" style={{ minWidth: "170px" }}>
              <SelectForm
                placeholder="Document"
                dropdownMatchSelectWidth={false}
                options={[
                  { label: "Visi", value: null },
                  ...this.state.documentTypes,
                ]}
                onChange={(value) =>
                  this.filterChange({
                    target: { name: "document_type_id", value },
                  })
                }
                value={this.state.filter.document_type_id}
              />
            </div>
            <div className="px-1" style={{ minWidth: "150px" }}>
              <SelectForm
                placeholder="Assignment"
                dropdownMatchSelectWidth={false}
                options={[
                  { label: "Visi", value: null },
                  { label: "Priskirtos", value: "yes" },
                  { label: "Nepriskirtos", value: "no" },
                ]}
                onChange={(value) =>
                  this.filterChange({
                    target: { name: "assigned", value },
                  })
                }
                value={this.state.filter.assigned}
              />
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_rivileService}
              array={this.props.rivileService}
              alertId_s="rivileAlert-s"
              //   alertId_e="rivileAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-black">
                      <th>PVM</th>
                      <th>Product ID</th>
                      <th>Stores</th>
                      <th>Title</th>
                      <th>Rivile code</th>
                      <th>Document</th>
                      <th>Plan</th>
                      <th>Alternative price</th>
                      <th>Alternative code</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.rivileService.map((item, index) => {
                      return (
                        <TableColumnRivileService
                          key={index}
                          index={index}
                          id={item.id}
                          item={item}
                          onAction={this.onAction}
                          onDelete={this.props.deleteRivileService}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <PaginationComp
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>

        <RivileServiceEditModal
          action={this.state.action}
          objectData={modalData}
          shops={this.state.shops}
          postRivileService={this.props.postRivileService}
          updateRivileServices={this.props.updateRivileServices}
          errors={this.props.errors}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  rivileService: state.rivileService.rivile_service,
  totals: state.rivileService.totals,
  loading_rivileService: state.rivileService.loading_rivile_service,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getRivileServices,
  updateRivileServices,
  deleteRivileService,
  postRivileService,
  clearErrors,
})(RivileServiceTemplate);
